import { render, staticRenderFns } from "./productIntroduce.vue?vue&type=template&id=5b393194&scoped=true&"
import script from "./productIntroduce.vue?vue&type=script&lang=js&"
export * from "./productIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./productIntroduce.vue?vue&type=style&index=0&id=5b393194&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b393194",
  null
  
)

export default component.exports